import ReactDOM from 'react-dom/client';
import 'moment/locale/pt-br';
import ThemeProvider from './Contexts/ThemeProvider';
import AppProvider from './Contexts/AppProvider';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <div className="App">
    <ThemeProvider>
      <AppProvider>
          <App />
      </AppProvider>
    </ThemeProvider>
  </div>
);
